import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { Directive, Input } from '@angular/core';
import { DateValidator } from '../validators/date.validator';

/*
 This is a clone MinDateValidator with input value change and revalidation support
*/
@Directive({
  standalone: false,
  selector: '[iesResponsiveMinDate]',
  providers: [
    {
      provide: NG_VALIDATORS,
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      useExisting: ResponsiveMinDateValidator,
      multi: true,
    },
  ],
})
export class ResponsiveMinDateValidator implements Validator {
  private _onChange?: () => void;
  private _minTime;
  private _message;

  @Input('iesResponsiveMinDateStrFormate') dateFormat = 'YYYYMM';

  @Input('iesResponsiveMinDate')
  get minDateValue() {
    return this._minTime;
  }

  set minDateValue(value) {
    this._minTime = value;
    if (this._onChange) {
      this._onChange();
    }
  }

  @Input('iesMinDateErrorMessage')
  get message() {
    return this._message;
  }

  set message(value) {
    this._message = value;
    if (this._onChange) {
      this._onChange();
    }
  }

  validate(control: AbstractControl) {
    if (typeof control.value === 'string') {
      return DateValidator.minDateStr(this.minDateValue, this.dateFormat, '', this.message)(control);
    }

    return DateValidator.minDate(this.minDateValue, '', this.message)(control);
  }

  registerOnValidatorChange(fn: () => void): void {
    this._onChange = fn;
  }
}
